import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Loader from "./../../shared/loader";
import { fetchItems, ITEM_FRONEND_URL, NAME_FOR_UI } from "./ducks/actions";
import AddIcon from "../icons/add";
import List from "./list";
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";

function ListItemsContainer(props) {
  const filmId = props.match.params.filmId;
  const { fetchItems, loading, items, errors, readOnly } = props;

  useEffect(() => {
    fetchItems(filmId);
  }, []);

  function renderLoading() {
    return <Loader />;
  }

  function renderItems(items, filmId) {
    return (
      <ScrollIntoView
        className="blade-menu"
        path={`/films/:filmId/${ITEM_FRONEND_URL}`}
        loading={loading}>
        <List items={items} filmId={filmId} />
        {!readOnly && !window.location.pathname.endsWith("add") && <NavLink
          to={`/films/${filmId}/${ITEM_FRONEND_URL}/add`}
          activeClassName={
            "is-active " + window.location.pathname.endsWith("add")
              ? "disabled"
              : ""
          }
          className="button is-transparent is-add">
          <AddIcon className="white-icon" />
          Add {NAME_FOR_UI}
        </NavLink>}
      </ScrollIntoView>
    );
  }

  return loading ? renderLoading() : renderItems(items, filmId);
}

function mapStateToProps(state) {
  const { items, loading, errors, readOnly } = state.soundEffectsState;
  return { items, loading, errors, readOnly };
}

export default connect(mapStateToProps, {
  fetchItems
})(ListItemsContainer);
